import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { FeedProduct } from '@vestiaire/api-sdk-angular';
import { FeedProfile } from '@vestiaire/api-sdk-angular';
import { ISeeProduct } from '../feed-card-new-ins/feed-card-new-ins.component';
import { ILikeProduct } from '../feed-card-new-ins/feed-card-new-ins.component';

@Component({
  selector: 'vc-feed-card-price-drops',
  templateUrl: './feed-card-price-drops.component.html',
  styleUrls: ['./feed-card-price-drops.component.scss', '../products-card.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedCardPriceDropsComponent {
  @Input() activities: FeedProduct[];
  @Input() profile: FeedProfile;
  @Input() totalCardActivities: number;
  @Input() likedItems: string[];

  @Output() seeProduct = new EventEmitter<ISeeProduct>();
  @Output() likeProduct = new EventEmitter<ILikeProduct>();
  @Output() seeMoreProduct = new EventEmitter<string>();
}
